<template>
	<div role="menuitem" :class="disabled ? 'disabled menuitem': 'menu-item'" @click="onSelect">
		<t-timpex-icon
			v-if="icon"
			type="bp"
			:icon="icon"
			:class="intent"
			class="menu-item-icon"
		/>
		<span
			:class="[{bold: bold}, intent]"
			class="menu-item-inner"
		>
			<slot>{{value}}</slot>
		</span>
		<span
			v-if="hasSecondaryTextOrSlotAfter"
			:class="intent"
			class="menu-item-secondary"
		>
			<slot name="after">
				{{secondaryText}}
			</slot>
		</span>
	</div>
</template>

<script>
import menuItemMixin from './menuItemMixin';
import TTimpexIcon from '@/components/evergreen/timpex/icons/TTimpexIcon';
export default {
	name: 'TMenuItem',
	components: { TTimpexIcon },
	mixins: [menuItemMixin],
	props: {
		intent: String,
		secondaryText: String,
		icon: String,
		disabled: Boolean
	},
	computed: {
		hasSecondaryTextOrSlotAfter() {
			return Boolean(this.secondaryText) || Boolean(this.$slots.after);
		}
	},
	methods: {
		onSelect(event) {
			if (this.disabled)
				return;
			this.$emit('click', event);
			this.$emit('select');
		},

	},
};
</script>

<style lang="scss" scoped>
@import '~@/components/evergreen/scss/colors';
@import '~@/components/evergreen/scss/text';
	.menu-item {
		@extend %font-families-ui;
		@extend %text-default;
		user-select: none;
		color: get-color($text, 'muted');
		margin-top: 0;
		height: 32px;
		cursor: pointer;
		outline: none;
		display: flex;
		box-sizing: border-box;
		align-items: center;
		&:hover {
			background-color: rgba(67, 90, 111, 0.1);
		}
		&:active {
			background-color: rgba(16, 112, 202, 0.2);
		}
	}

	.menu-item-icon {
		color: get-color($icon, 'default');
		margin-left: 16px;
		margin-right: -4px;
		max-height: 16px;
		width: 16px;
		box-sizing: border-box;
	}

.disabled {
	cursor: not-allowed;
	opacity: 0.8;
	background-image: none !important;
	background-color: rgba(67, 90, 111, 0.06) !important;
	color: rgba(67, 90, 111, 0.7) !important;
	box-shadow: none;
}

	.menu-item-inner {
		flex:1;
		margin-left: 16px;
		margin-right: 16px;
		box-sizing: border-box;
		&.bold {
			font-weight: 500;
		}
	}

	.menu-item-secondary {
		margin-right: 16px;
		box-sizing: border-box;
	}

	.success {
		color: get-color($text, 'success');
	}

	.info {
		color: get-color($text, 'info');
	}

	.danger {
		color: get-color($text, 'danger');
	}

	.warning {
		color: get-color($text, 'warning');
	}
</style>
